<template>
  <div class="main">
    <clouded-glass class="space-choose">
      <div class="h-100 overflow" slot="content">
        <div class="space-button text-center">
          <span @touchstart="openDialog({},'same')" @click="openDialog({},'same')">新建同级空间 </span>
          <span @touchstart="openDialog({},'children')" @click="openDialog({},'children')">新建子级空间</span>
        </div>
        <div class="space-button text-center">
          <span @touchstart="openDialog(checkSpace,'edit')" @click="openDialog(checkSpace,'edit')">编辑选中空间</span>
          <span class="text-danger"
                style="border-color: darkred"
             @touchstart="removeSpace"   @click="removeSpace">删除选中空间</span>
        </div>
        <div class="current-location" style="margin-right: 21px;">
          <el-input class="inline-input" v-model="name" placeholder="请输入搜索的空间名称" size="mini"
                    @change="changeName"/>
        </div>
        <div class="current-location">
          <img alt="" src="../../../../assets/images/icon/location.png"><span
          class="text-nowrap ">当前空间：{{ checkSpace.cnName }}</span>
        </div>
        <space-tree-show style="height: calc(100% - 155px);overflow-y:auto;" class="space" ref="space" :checkShow=true
                         @spaceChoose="spaceChoose" @getAllDevice="getAllDevice"/>
      </div>
    </clouded-glass>
    <div class="device-list">
      <div class="nav-bar-div">
        <nav-bar :deviceTag='deviceTag' :DeviceStatusTags="DeviceStatusTags" :status="status"
                 @statusChange="statusChange" @deviceStatusChange="deviceStatusChange" class="nav-bar" ref="navBar"
                 @tagsChange="tagsChange"/>
      </div>
      <div class="cross-line"></div>
      <div class="nav-bar-div" style="margin-bottom: 0.5%">
        <el-button style="margin-right: 5px;" @touchstart="selectAll" @click="selectAll">全选</el-button>
        <el-button style="margin-left: 5px;color: #299FFB;" @click="showImportDialog">导入</el-button>
        <el-button style="margin-left: 5px;color: #299FFB" @touchstart="exportExcel" @click="exportExcel">导出</el-button>
        <!-- <el-button style="margin-left: 5px;color: #fb2929">删除</el-button>
        <el-button style="margin-left: 15px;color: rgba(7, 230, 248, 1)">添加</el-button> -->
        <el-popover placement="bottom" width="300" trigger="click" popper-class="popoverSetColumnClass"
                    style="float: right">
          <el-checkbox-group v-model="colOptions">
            <el-checkbox style="width: 100px;" v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
          </el-checkbox-group>
          <el-button size="mini" v-show="DeviceStatusTags==2?true:false"
                     style="float: right; margin-bottom: 10px;height: 30px;margin-left: 10px"
                     slot="reference">
            <b-icon aria-hidden="true" class="text-lightBlue" icon="gear-fill"></b-icon>
          </el-button>
        </el-popover>
      </div>

      <el-row class="device overflow">
        <ul style="padding: 0">
          <device-show-comp-table ref="deviceTable" v-show="DeviceStatusTags==2?true:false"
                                  :table-columns="tableColumns"
                                  :device-info="deviceInfoList"
                                  :space-value="checkSpace.cnName"
                                  :spaceInfoId="spaceInfoId"
                                  @getDeviceList="getDeviceList"
                                  @tableViewSelectChange="tableViewSelectChange"
                                  :device-show-brand="deviceShowBrand"
                                  :device-show-model="deviceShowModel"/>

          <li v-show="DeviceStatusTags==1?true:false" v-for="(item) in deviceInfoList" :key="item.id">
            <el-checkbox-group v-model="cardSelectAll" @change="cardViewSelectChange">
              <el-checkbox style="float: right;margin-right: 5px;margin-top: 5px;" :key="item.id"
                           :label="item">
                <br>
              </el-checkbox>
            </el-checkbox-group>
            <device-show-comp :device-info="item"
                              :space-value="checkSpace.cnName"
                              :spaceInfoId="spaceInfoId"
                              @getDeviceList="getDeviceList"
                              :device-show-brand="deviceShowBrand"
                              :device-show-model="deviceShowModel"/>
          </li>
        </ul>
      </el-row>
    </div>

    <!-- 新建同级空间，新建子级空间，编辑选中空间-->
    <dialog-component
      :closeClick="false"
      :dialog-title="title"
      :dialogVisible.sync="deviceDialogVisible"
      center
      width="45vw"
      @dialogClose="(data) => this.deviceDialogVisible = data">
      <div slot="content" style="padding: 10px 30px 20px 30px;">
        <SpaceModify :options="options" :spaceForm='spaceForm'
                     :spaceLabel="spaceLabel"
                     :spaceValue="checkSpace.cnName" @receiveData="receiveData">
        </SpaceModify>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="() => {this.deviceDialogVisible = false;this.spaceForm={}}" @click="() => {this.deviceDialogVisible = false;this.spaceForm={}}" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" type="primary" size="mini">保 存</el-button>
      </div>
    </dialog-component>

    <!-- 修改导入弹窗部分 -->
    <dialog-component
      :closeClick="false"
      dialogTitle="导入设备"
      :dialogVisible.sync="importDialogVisible"
      center
      width="500px"
      @dialogClose="(data) => this.importDialogVisible = data">
      <div slot="content" style="padding: 20px 30px;">
        <div class="import-area">
          <el-upload
            ref="uploadImport"
            :show-file-list="true"
            accept=".xlsx"
            :auto-upload="true"
            :http-request="uploadImportFile"
            :before-upload="beforeImportUpload"
            :on-change="submitImportFile"
            :on-exceed="handleImportExceed"
            :limit="1"
            drag
            class="upload-demo"
            style="width: 100%;">
            <i class="el-icon-upload" style="font-size:30px"></i>
            <div class="el-upload__text">拖拽文件到此处或 <em>点击上传</em></div>
          </el-upload>
        </div>
        <div class="download-area" style="text-align: center; margin-top: 15px;">
          <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import SpaceModify from "@/views/basic_operations/device_management/device_manager/comp/SpaceModify";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import NavBar from "@/views/basic_operations/device_management/device_manager/comp/NavBar";
import DeviceShowComp from "@/views/basic_operations/device_management/device_manager/comp/DeviceShowComp";
import DeviceShowCompTable from "@/views/basic_operations/device_management/device_manager/comp/DeviceShowCompTable";
import {exportDeviceExcel, getUserListBySpaceIdAndStatus, importDeviceExcel} from "@/network/device-info";
import {deleteById, getSpaceInfoById, saveByLevel} from "@/network/space-info";
import DialogComponent from "../../../../components/DialogComponent";
import {getSystematicByCodes} from "@/network/systematic";
import {tree} from "@/network/ext-geography";
import _ from 'lodash';

export default {
  name: "DeviceManager",
  components: {DialogComponent, DeviceShowCompTable, NavBar, SpaceTreeShow, CloudedGlass, SpaceModify, DeviceShowComp},
  data() {
    return {
      // 筛选的空间名称
      name: "",
      deviceDialogVisible: false,
      operate: "",
      spaceForm: {},
      receiveSpaceForm: {},
      checkSpace: {},
      deviceInfoList: [],
      // 当前空间id
      spaceInfoId: '',
      // 当前空间
      // 当前所选设备标签
      deviceTag: '',
      // 当前所选状态
      status: '',
      title: '标题',
      spaceLabel: '',
      levelType: 0,
      code: null,
      options: [],
      deviceShowBrand: true,
      deviceShowModel: true,
      // 设备列表显示方式，默认表格显示。1为图标显示
      DeviceStatusTags: 2,
      // 选中项
      colOptions: [],
      // 可选项
      colSelect: [],
      // field对应数据返回的字段名，title对应列头名，isShow代表这列是否显示
      tableColumns: [
        {field: 'checkBox'},
        {field: 'name', title: "设备名称", width: '180', isShow: true, align: 'center'},
        {field: 'status', title: "运行状态", width: '80', isShow: true, align: 'center'},
        {field: 'typeCnName', title: "类型/品牌/型号", width: '350', isShow: true, align: 'center'},
        {field: 'note', title: "备注", width: '100', isShow: true, align: 'center'},
      ],
      // 卡片类型选中集合
      cardSelectAll: [],
      // 导入excel
      importFile: {},
      importDialogVisible: false, // 导入弹窗是否显示
    }
  },
  inject: ['overflow'],
  created() {
    var _this = this;
    let columnList = localStorage.getItem("deviceColSelect"); // 初始化从本地缓存中获取，如果有，则用缓存中的数据
    for (let i = 0; i < _this.tableColumns.length; i++) {
      // 去掉checkbox的自定义列
      if (_this.tableColumns[i].field.indexOf('checkBox') != -1) {
        continue
      }
      _this.colSelect.push(_this.tableColumns[i].title);
      // 初始化不想展示的列可以放在这个条件里
      if (columnList != null && columnList.length > 0) {
        if (columnList.indexOf(_this.tableColumns[i].title) == -1) {
          continue
        }
      }
      _this.colOptions.push(_this.tableColumns[i].title);
    }
  },
  mounted() {
    this.getSystematicByCodes();
    getSystematicByCodes(['dcim_device_show_brand', 'dcim_device_show_model']).then(res => {
      if (res.code === 0) {
        res.data.forEach(item => {
          if (item.code === 'dcim_device_show_brand') {
            this.deviceShowBrand = item.val1 === 'true'
          } else if (item.code === 'dcim_device_show_model') {
            this.deviceShowModel = item.val1 === 'true'
          }
        })
      }
    })
  },
  watch: {
    // 监听colOptions值的变化
    colOptions(valArr) {
      localStorage.setItem("deviceColSelect", JSON.stringify(valArr)) // 将修改结果放入本地缓存
      var arr = this.colSelect.filter(i => valArr.indexOf(i) < 0); // 未选中
      // 将未选中的isShow改成false
      this.tableColumns.filter(i => {
        if (arr.indexOf(i.title) != -1) {
          i.isShow = false;
        } else {
          i.isShow = true;
        }
      });
    }
  },
  methods: {
    getSystematicByCodes() {
      getSystematicByCodes("space_level_code").then(res => {
        if (res.code === 0) {
          if (res.data !== null && res.data.length > 0) {
            this.code = res.data[0].val1
          }
        }
        this.getGeographyTreeData();
      })
    },
    // 获取省市区
    getGeographyTreeData() {
      tree().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          if (this.code) {
            this.getTreeData(res.data);
          } else {
            this.options = res.data
          }
        }
      });
    },
    getTreeData(data) {
      for (let item of data) {
        if (this.code === item.id) {
          this.options = [item]
          this.levelType = item.levelType + 1;
          return;
        }
        if (item.children !== undefined) {
          this.getTreeData(item.children)
        }
      }
    },
    getAllDevice() {
      getUserListBySpaceIdAndStatus().then(res => {
        if (res.code === 0) {
          this.deviceInfoList = res.data
          setTimeout(() => {
            this.overflow()
            this.$refs.navBar.getUnboundDevices();
          }, 500)
        }
      })
    },
    spaceChoose(spaceInfo) {
      this.spaceInfoId = spaceInfo.id;
      this.spaceLabel = spaceInfo.title;
      this.getDeviceList();
      this.getSpaceInfo()
    },
    close() {
      this.spaceForm = {};
      this.deviceDialogVisible = false;
    },
    // 保存
    preservation() {
      if (this.checkValue()) {
        this.receiveSpaceForm.type = this.receiveSpaceForm.type === 1 ? this.receiveSpaceForm.type : 2;
        // 保存
        this.receiveSpaceForm.code = this.receiveSpaceForm.region[this.receiveSpaceForm.region.length - 1];
        this.receiveSpaceForm.levelType = this.levelType;
        saveByLevel(this.receiveSpaceForm).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功');
          } else {
            this.$message.error(res.message);
          }
          this.deviceDialogVisible = false;
          this.getSpaceInfo()
          this.receiveSpaceForm = {};
          this.$refs.space.ztree();
        });
      }
    },
    receiveData(data) {
      this.receiveSpaceForm = data
    },
    checkValue() {
      if (!this.$stringIsNotNullAndEmpty(this.receiveSpaceForm.cnName)) {
        this.$message.error('请输入空间名称');
        return false;
      }
      if (this.receiveSpaceForm.cnName.length > 20) {
        this.$message.error('空间名称过长');
        return false;
      }
      if (!this.receiveSpaceForm.region) {
        this.$message.error('请选择行政区域');
        return false;
      }
      if (this.receiveSpaceForm.id) {
        if (this.deviceInfoList && this.deviceInfoList.length > 0 && this.receiveSpaceForm.type === 1) {
          this.$message.error('当前空间下还有设备，不能修改为逻辑空间!');
          return false;
        }
      }
      return true;
    },
    openDialog(row, operate) {
      this.operate = operate
      const spaceForm = _.cloneDeep(row)
      if (operate === 'same') {
        this.spaceLabel = '同级空间';
        this.title = '新建同级空间';
        spaceForm.parentId = this.checkSpace.parentId;
        spaceForm.parentName = this.checkSpace.parentName;
        spaceForm.latitude = "";
        spaceForm.longitude = "";
        spaceForm.type = 0;
      } else if (operate === 'children') {
        this.spaceLabel = '父级空间';
        this.title = '新建子级空间';
        spaceForm.parentId = this.checkSpace.id;
        spaceForm.parentName = this.checkSpace.cnName;
        spaceForm.latitude = "";
        spaceForm.longitude = "";
        spaceForm.type = 0;

      } else if (operate === 'edit') {
        this.title = '编辑选中空间';
        this.spaceLabel = '操作空间';
        spaceForm.region = ['100000'];
        if (spaceForm.provinceId) spaceForm.region.push(spaceForm.provinceId + '')
        if (spaceForm.cityId) spaceForm.region.push(spaceForm.cityId + '')
        if (spaceForm.districtId) spaceForm.region.push(spaceForm.districtId + '')
        if (spaceForm.streetId) spaceForm.region.push(spaceForm.streetId + '')
        if (this.levelType > 1) {
          spaceForm.region = spaceForm.region.splice(this.levelType - 1, spaceForm.region.length)
        }
        spaceForm.type = spaceForm.type === 1 ? spaceForm.type : 0;

      }
      this.spaceForm = spaceForm;
      this.deviceDialogVisible = true;
    },
    // 删除选中空间
    removeSpace() {
      if (!this.deviceInfoList || this.deviceInfoList.length <= 0) {
        this.$confirm('是否确认删除空间：' + this.checkSpace.cnName, {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          callback: action => {
            if (action === 'confirm') {
              deleteById(this.spaceInfoId).then(res => {
                if (res.code === 0) {
                  this.$message.success('操作成功');
                } else {
                  this.$message.error(res.message);
                }
                this.$refs.space.ztree();
              });
            }
          }
        })
      } else {
        this.$message.error('当前空间下已绑定设备，请先移除设备');
      }

    },
    // 获取当前空间信息
    getSpaceInfo() {
      getSpaceInfoById(this.spaceInfoId).then(res => {
        if (res.code === 0) {
          this.checkSpace = res.data;
        }
      })
    },
    getDeviceList() {
      getUserListBySpaceIdAndStatus(this.spaceInfoId, this.deviceTag, this.status).then(res => {
        if (res.code === 0) {
          this.deviceInfoList = res.data
          setTimeout(() => {
            this.overflow()
            this.$refs.navBar.getUnboundDevices();
          }, 500)
        }
      })
    },
    tagsChange(val) {
      this.deviceTag = val;
      this.getDeviceList();
    },
    statusChange(val) {
      this.status = val;
      this.getDeviceList();
    },
    deviceStatusChange(newVal) {
      this.DeviceStatusTags = newVal;
    },
    // 表格全选
    selectAll() {
      this.$refs.deviceTable.$refs.childDeviceTable.toggleAllSelection();
    },
    // 导出
    exportExcel() {
      const h = this.$createElement;
      if (this.cardSelectAll.length <= 0) {
        this.$message({
          message: '请先选择要导出的设备!',
          type: 'info'
        });
        return;
      }
      this.$confirm("提示", {
        title: '提示',
        message: h('div', {class: 'tips'}, [
          h('div', '确定要导出已选中设备吗？')
        ]),
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            var idList = this.cardSelectAll.map(item => item.id)
            exportDeviceExcel(idList).then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: '导出成功!',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: '导出失败!',
                  type: 'success'
                });
              }
            })
            console.log(this.cardSelectAll)
          }
        }
      })
    },
    // 导入限制
    handleImportExceed() {
      this.$message({type: 'error', message: '最多支持1个附件上传'})
    },
    // 导入之前
    beforeImportUpload(file) {
      let fileSize = file.size
      const FIVE_M = 5 * 1024 * 1024;
      //大于5M，不允许上传
      if (fileSize > FIVE_M) {
        this.$message.error("最大上传5M")
        return;
      }
    },
    // 导入改变事件
    submitImportFile(file) {
      // 获取上传的文件
      this.importFile = file.raw
    },
    // 显示导入弹窗
    showImportDialog() {
      this.importDialogVisible = true;
    },
    // 下载模板
    downloadTemplate() {
      // 这里需要添加下载模板的逻辑，通常是调用后端API
      // 例如：
      // downloadDeviceTemplate().then(res => {
      //   // 处理下载逻辑
      // })
      
      // 如果后端提供文件下载链接，可以直接跳转
      window.open('/static/设备导入模板.xlsx', '_blank');
    },
    // 修改uploadImportFile方法，添加关闭弹窗逻辑
    uploadImportFile() {
      // 显示加载中
      const loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 使用form表单的数据格式
      let params = new FormData()
      params.append("file", this.importFile)
      params.append("spaceId", this.spaceInfoId)
      params.append("spaceName", this.spaceLabel)
      
      importDeviceExcel(params).then(res => {
        loading.close(); // 关闭加载
        
        if (res.code === 0) {
          this.$message({
            message: '导入成功!',
            type: 'success'
          });
          this.getDeviceList();
          this.importDialogVisible = false; // 导入成功后关闭弹窗
        } else {
          this.$message({
            message: res.message || '导入失败!',
            type: 'error'
          });
        }
      }).catch(err => {
        loading.close(); // 错误时也要关闭加载
        this.$message.error('导入失败: ' + (err.message || '未知错误'));
      }).finally(() => {
        // 清空上传列表
        this.$refs.uploadImport.clearFiles();
        // 清空本地缓存
        this.importFile = null;
      });
    },
    // 卡片类型视图选中改变方法
    cardViewSelectChange(value) {
      // 先清空表格所有勾选数据
      this.$refs.deviceTable.$refs.childDeviceTable.clearSelection();
      // 同步勾选表格数据
      value.forEach(row => {
        this.$refs.deviceTable.$refs.childDeviceTable.toggleRowSelection(row, true)
      })
    },
    // 表格类型视图选中改变方法
    tableViewSelectChange(value) {
      this.cardSelectAll = value
    },
    // 空间筛选
    changeName(){
      this.$refs.space.changName(this.name);
    }
  }
}
</script>

<style scoped>
.main {
  padding: 10px 10px 0;
  height: calc(100vh - 90px);
}

ul li {
  list-style: none;
  float: left;
}

/*空间选择*/
.space-choose {
  float: left;
  height: 100%;
  width: 240px;
}

.space-button {
  margin-top: 20px;
}

.space-button span {
  margin: 0 5px 0 5px;
  width: 84px;
  height: 19px;
  line-height: 19px;
  color: #07E6F8;
  border-bottom: 1px solid #41a6ad;
  opacity: 1;
}

.space-button span:hover {
  cursor: pointer;
}

.current-location {
  margin: 30px 0 10px 20px;
  height: 19px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
}

.current-location img {
  margin-right: 5px;
  margin-top: -5px;
}

.space-choose .space {
  margin: 8px 0 10px 30px;
  width: calc(100% - 30);
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
  font-size: 0.85rem;
}

/*设备列表*/
.device-list {
  margin-left: 250px;
  width: calc(100vw - 485px);
}

/*-----------------分割线-------------------*/
.cross-line {
  width: 100%;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.2;
  margin: 5px;
}

.device-list .device {
  overflow: auto;
  height: calc(100vh - 140px);
}


@media (max-width: 1245px) {
  .device-list .device {
    overflow: auto;
    height: calc(100vh - 240px);
  }
}

@media (max-width: 800px) {
  .space-choose {
    width: 100%;
    height: auto;
  }

  .device-list {
    margin-left: 0;
    width: auto;
  }

  .nav-bar-div {
    width: 100%;
    overflow: auto;
  }

  .nav-bar {
    width: 100vw;
    overflow: auto;
  }
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #FFFFFF;
}

::v-deep .el-upload{
  width: 100%;
}
::v-deep .el-upload  .el-upload-dragger {
    width: 100% !important;
    height: auto !important;
    padding-bottom: 10px;
  }
</style>
<style>
.popoverSetColumnClass {
  background: #083966;
  border: 1px solid #083966;
  text-align: left;
  padding-left: 1%;
}
</style>
